import axios from "axios";
import { isClientAccess } from "Utils";

export const getAnnexeList = (
  uen,
  filter,
  paginationPage,
  pageSize,
  currentOrganization,
  portail
) => {
  let { fileName, category, year, type } = filter;

  const requestUrl = `/data/annexe`;
  let filters = [];

  if (fileName && fileName.length > 0) {
    filters.push({
      property: "fileName",
      value: fileName,
      operator: "like"
    });
  }
  if (category && category.value) {
    filters.push({
      property: "category",
      value: category.value,
      operator: "eq"
    });
  }

  if (type && type.code === "OTHERS") {
    filters.push({
      property: "category",
      value: type.value,
      operator: "eq"
    });
  } else if (type && type.code === "ANNEXES") {
    filters.push({
      property: "category",
      value: type.value,
      operator: "neq"
    });
  }

  if (year && year.value) {
    filters.push({
      property: "year",
      value: year.value,
      operator: "eq"
    });
  }

  if (isClientAccess(currentOrganization, portail)) {
    filters.push({
      property: "hidden",
      value: 0,
      operator: "eq"
    });
  }

  let sort = [];
  sort.push({
    property: "createdAt",
    dir: "desc"
  });

  let params = {
    fields: "*",
    uen,
    limit: pageSize || 10,
    start: !paginationPage ? 0 : (paginationPage - 1) * pageSize
  };

  params.filter = JSON.stringify(filters).replace(
    /SPECIAL_CHAR_TO_REPLACE/g,
    "\\"
  );
  params.sort = JSON.stringify(sort);

  return axios.get(requestUrl, { params });
};

export const getAnnexeTemporaryLink = (id, filePath) => {
  const requestUrl = `/data/annexe/tmp-url`;

  let params = {
    id: id,
    filePath: filePath
  };

  return axios.get(requestUrl, { params });
};

export const deleteAnnexe = ({ uen, id }) => {
  const requestUrl = `/data/annexe/delete`;

  let formData = new FormData();
  formData.append("uen", uen);
  formData.append("id", id);

  return axios.post(requestUrl, formData);
};

export const setMainAnnexe = ({ uen, id }) => {
  const requestUrl = `/data/annexe/main`;

  let formData = new FormData();
  formData.append("uen", uen);
  formData.append("id", id);

  return axios.post(requestUrl, formData);
};

export const toggleHiddenAnnexe = ({ uen, id }) => {
  const requestUrl = `/data/annexe/hidden`;

  let formData = new FormData();
  formData.append("uen", uen);
  formData.append("id", id);

  return axios.post(requestUrl, formData);
};

export const toggleCertifiedAnnexe = ({ uen, id }) => {
  const requestUrl = `/data/annexe/certif`;

  let formData = new FormData();
  formData.append("uen", uen);
  formData.append("id", id);

  return axios.post(requestUrl, formData);
};

export const getBalanceSheetAttachments = ({ clientUen, fiduciaryUen }) => {
  const requestUrl = `/data/annexe/balance-attachments`;

  let params = {
    clientUen: clientUen,
    fiduciaryUen: fiduciaryUen
  };

  return axios.get(requestUrl, { params });
};



// WEBPACK FOOTER //
// ./src/api/annexe.js